export const appStoreConstants = {
  GET_CONFIGURED_APPSTORE_APPS_REQUEST: 'GET_CONFIGURED_APPSTORE_APPS_REQUEST',
  GET_CONFIGURED_APPSTORE_APPS_SUCCESS: 'GET_CONFIGURED_APPSTORE_APPS_SUCCESS',
  GET_CONFIGURED_APPSTORE_APPS_FAILURE: 'GET_CONFIGURED_APPSTORE_APPS_FAILURE',
  GET_APPSTORE_APPS_REQUEST: 'GET_APPSTORE_APPS_REQUEST',
  GET_APPSTORE_APPS_SUCCESS: 'GET_APPSTORE_APPS_SUCCESS',
  GET_APPSTORE_APPS_FAILURE: 'GET_APPSTORE_APPS_FAILURE',
};
